export default {
  env: 'production',
  website: 'dashboard.metasense.com.au',
  apiServer: 'api.v2.metasense.com.au',
  staticServer: 'static.metasense.com.au',
  ssl: true
}
